export const WALLET_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
];

export const formatWalletLabel = (key) =>
  key.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());

export const getWalletTransactionTypes = (
  walletTransactionDistributionData,
) =>
  Object.entries(walletTransactionDistributionData?.data || {}).map(
    ([key, value]) => ({
      name: formatWalletLabel(key),
      value: value.percentage,
    }),
  );

export const getFormattedAgentWalletCards = (agentWalletAnalyticsData) =>
  agentWalletAnalyticsData?.data
    ? Object.entries(agentWalletAnalyticsData.data || {}).map(([key, value]) => {
        const isCurrencyField = "currency" in value;

        return {
          title: formatWalletLabel(key),
          value: isCurrencyField
            ? `${value.currency} ${Number(value.value).toLocaleString()}`
            : Number(value.value).toLocaleString(),
          subtitle: value.entityName || "",
          trend: `${value.growthPercentage}%`,
          trendColor:
            value.trend === "upward"
              ? "text-green-600"
              : value.trend === "downward"
                ? "text-red-600"
                : "text-gray-500",
        };
      })
    : [];
